import React, { useEffect, useContext } from 'react';
import TemplateData from '../utility/getTemplateData';
import { BodyText } from '@paypalcorp/pp-react';
import ConfirmationSocialShare from './ConfirmationSocialShare';
import ConfirmationTransactionId from './ConfirmationTransactionId';
import OfferConfirmation from '../components/offerConfirmation';
import PropTypes from 'prop-types';
import SignUpAlert from '../components/guest/SignUpAlert';
import VoucherFlowDisclaimer from '../components/voucherFlowDisclaimer';
import ConfirmationRedirect from './ConfirmationRedirect';
import { endCustomCPLTrackingForConfirmationPage } from '../utility/cpl';
import {
  isInContext,
  isMobileOrInContext,
  onComplete,
  isMWebNoReturnURL,
} from '../utility/inContextDonation';
import { isPPFundraising } from '../utility/productIntegrationUtils';
import CloseButton from '../components/CloseButton';
import classNames from 'classnames';
import DoneLink from './DoneLink';
import { BannerImage } from '@paypalcorp/donate-react';
import { isCampaigns } from '../utility/productIntegrationUtils';
import { addFeature } from '../fpti/helper';
import { FEATURES } from '../fpti/fptiConstants';
import { MessageFormat } from '@paypalcorp/worldready';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';

function ConfirmationView(props) {
  const worldReady = useContext(WorldReadyContext);
  const getSocialMessage = (id, params) => {
    return new MessageFormat(worldReady, {
      id: isCampaigns()
        ? `landing.social.${id}`
        : `confirmation.confirmation.social.${id}`,
    }).format(params);
  };
  const {
    autoRedirect,
    autoRedirectUrl,
    autoRedirectMethod,
    footer,
    handleRedirect,
    hostedButtonId,
    illustration,
    isSignUp,
    isVoucherFlow,
    message,
    offerProgram,
    orgName,
    postBackData,
    returnTo,
    returnText,
    signUpProps,
    syncReturnUrl,
    txnId,
    personalizedMessages,
    isExternalFlow,
    campaignId,
  } = props;

  useEffect(() => {
    endCustomCPLTrackingForConfirmationPage();
  }, []);

  useEffect(() => {
    onComplete(postBackData);
  }, []);

  function buildSocialMessages() {
    if (isCampaigns()) {
      return {
        social: {
          emailSubject: getSocialMessage('emailSubject', {
            donationName: '{donationName}',
          }),
          emailBody: getSocialMessage('emailBody', {
            donationName: '{donationName}',
            url: '{url}',
          }),
          mobileText: getSocialMessage('mobileText', {
            donationName: '{donationName}',
          }),
          facebookMessage: getSocialMessage('facebookMessage', {
            donationName: '{donationName}',
            url: '{url}',
          }),
          twitterMessage: getSocialMessage('twitterMessage', {
            donationName: '{donationName}',
          }),
          whatsappMessage: getSocialMessage('whatsappMessage', {
            donationName: '{donationName}',
          }),
          copyLinkHeader: getSocialMessage('copyLinkHeader'),
          copyLinkSubheaderBefore: getSocialMessage('copyLinkSubheaderBefore'),
          copyLinkSubheader: getSocialMessage('copyLinkSubheader'),
          copiedText: getSocialMessage('copiedText'),
          copyText: getSocialMessage('copyText'),
          subheader: getSocialMessage('subheader'),
          shareGeneric: getSocialMessage('shareGeneric'),
        },
      };
    }
    return {
      social: {
        emailSubject: getSocialMessage('emailSubject', {
          donationName: '{donationName}',
        }),
        emailBody: getSocialMessage('emailBody', {
          donationName: '{donationName}',
          url: '{url}',
        }),
        mobileText: getSocialMessage('mobileText', {
          donationName: '{donationName}',
        }),
        facebookMessage: getSocialMessage('facebookMessage', {
          donationName: '{donationName}',
        }),
        twitterMessage: getSocialMessage('twitterMessage', {
          donationName: '{donationName}',
        }),
        whatsappMessage: getSocialMessage('whatsappMessage', {
          donationName: '{donationName}',
        }),
        copyLinkHeader: getSocialMessage('copyLinkHeader'),
        copyLinkSubheader: getSocialMessage('copyLinkSubheader'),
        copiedText: getSocialMessage('copiedText'),
        copyText: getSocialMessage('copyText'),
        subheader: getSocialMessage('subheader'),
        shareGeneric: getSocialMessage('shareGeneric'),
        shareWithMatch: getSocialMessage('shareWithMatch'),
        unhosted: {
          emailSubject: getSocialMessage('unhosted.emailSubject'),
          emailBody: getSocialMessage('unhosted.emailBody', {
            url: '{url}',
          }),
          mobileText: getSocialMessage('unhosted.mobileText'),
          facebookMessage: getSocialMessage('unhosted.facebookMessage'),
          twitterMessage: getSocialMessage('unhosted.twitterMessage'),
          whatsappMessage: getSocialMessage('unhosted.whatsappMessage', {
            url: '{url}',
          }),
        },
      },
    };
  }

  function showSocialShare() {
    if (TemplateData.socialSharePreference) {
      addFeature(FEATURES.SOCIAL_SHARE_PREFERENCE);
      return (
        <ConfirmationSocialShare
          hostedButtonId={hostedButtonId}
          campaignId={campaignId}
          orgName={orgName}
          messages={buildSocialMessages()}
          email={TemplateData.donationEmail}
          personalizedMessages={personalizedMessages}
        />
      );
    }

    return null;
  }

  function confirmationClass() {
    return classNames(
      {
        gn_donate_wrapper: TemplateData.bannerUrl,
        donate_wrapper: !TemplateData.bannerUrl,
        confirmation: !TemplateData.bannerUrl,
      },
      { mobile_view: isMobileOrInContext() },
      {
        mobile_view_without_return_message: isMWebNoReturnURL(),
      },
      { ppf: isPPFundraising() }
    );
  }

  return (
    <div>
      {isSignUp && <SignUpAlert {...signUpProps} />}
      <div className={confirmationClass()}>
        {isExternalFlow && <CloseButton inverse />}
        {TemplateData.bannerUrl ? (
          <BannerImage src={TemplateData.bannerUrl} />
        ) : (
          <div> {illustration} </div>
        )}
        <div className="success_content">
          {message}

          {isExternalFlow && personalizedMessages.success_subheader ? (
            <BodyText className="text-center success_subheader">
              {personalizedMessages.success_subheader}
            </BodyText>
          ) : null}

          {isVoucherFlow && (
            <OfferConfirmation offerProgram={offerProgram} txnId={txnId} />
          )}

          {isVoucherFlow && <VoucherFlowDisclaimer />}

          {showSocialShare()}

          {!isExternalFlow && (
            <ConfirmationTransactionId transactionId={txnId} />
          )}

          {isExternalFlow && (
            <DoneLink
              doneContent={new MessageFormat(worldReady, {
                id: 'confirmation.confirmation.label.doneButton',
              }).format()}
              syncReturnUrl={syncReturnUrl}
              redirectUrl={autoRedirectUrl}
            />
          )}
        </div>
      </div>
      {!isInContext() && autoRedirect && autoRedirectUrl && (
        <ConfirmationRedirect
          autoRedirectMethod={autoRedirectMethod}
          autoRedirectUrl={autoRedirectUrl}
          handleRedirect={handleRedirect}
          orgName={orgName}
          postBackData={postBackData}
          returnText={returnText}
          returnTo={returnTo}
          syncReturnUrl={syncReturnUrl}
        />
      )}
      {footer}
    </div>
  );
}

ConfirmationView.propTypes = {
  autoRedirectMethod: PropTypes.string,
  autoRedirect: PropTypes.bool,
  autoRedirectUrl: PropTypes.string,
  footer: PropTypes.object,
  handleRedirect: PropTypes.func,
  hostedButtonId: PropTypes.string,
  isVoucherFlow: PropTypes.bool,
  illustration: PropTypes.object,
  isSignUp: PropTypes.bool,
  message: PropTypes.object,
  offerProgram: PropTypes.object,
  orgName: PropTypes.string,
  postBackData: PropTypes.object,
  redirect: PropTypes.func,
  returnTo: PropTypes.string,
  returnText: PropTypes.string,
  signUpProps: PropTypes.object,
  syncReturnUrl: PropTypes.string,
  txnId: PropTypes.string,
  personalizedMessages: PropTypes.object,
  isExternalFlow: PropTypes.bool,
  isOfacPending: PropTypes.bool,
  campaignId: PropTypes.string,
};

export default ConfirmationView;
